import RouteConfig from './config/RouteConfig';
import ConfirmationView from 'text!./views/confirmation.html';
import ContactUsView from 'text!./views/contact-us.html';
import CompositeFlowConfig from 'integration/gateway/quoteandbind/config/CompositeFlowConfig';
import ActionMessageUtil from './util/ActionMessageUtil';
import 'edge/gateway/policyjob/app';
import 'edge/quoteandbind/app';

export default angular.module('edge.gateway.quoteandbind.common.app', ['edge.quoteandbind.app', 'edge.gateway.policyjob.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).factory('qnb.CompositeFlowDefn', CompositeFlowConfig).factory('gateway.ActionMessageUtil', ActionMessageUtil).value('qnb.doInitialAvailabilityCheck', false).value('qnb.ViewModelCtx', {
    'AccountEmailRequired': false,
    'DriverEmailRequired': true,
    'AccountDOBRequired': false
}).value('qnb.endpointConfig', {
    'loadSaveEndpoint': 'gatewayquote/quote',
    'emailEndpoint': 'gatewayquote/quote',
    'customQuoteEndpoint': 'gatewayquote/customquote',
    'bopCoverablesEndpoint': 'gatewayquote/bopcoverables',
    'cpCoverablesEndpoint': 'gatewayquote/cpcoverables'
}).value('qnb.xCenterRouteConfig', 'pc').value('qnb.spreadsheetProcessorConfig', {
    'downloadTemplateURL': 'document/gateway/spreadsheetprocessor',
    'uploadTemplateURL': 'gateway/spreadsheetprocessor'
}).value('qnb.returnStateFn', function (model) {
    return ['quote.detail.summary', {
        submissionNumber: model.quoteID
    }];
}).value('qnb.effectiveDateStateFn', function (model) {
    switch (model.baseData.productCode.value) {
        case 'BusinessOwners':
            return ['effectiveDate-bop', {}];

        case 'CommercialProperty':
            return ['effectiveDate-cp', {}];

        default:
            return ['effectiveDate', {}];
    }
}).value('qnb.errorStateFn', function (model) {
    return ['quote.detail.summary', {
        submissionNumber: model.quoteID.value
    }];
})

// override base QnB configuration for agent portal
.run(['$state', function ($state) {
    var qnbconfirmationState = $state.get('qnbconfirmation');
    qnbconfirmationState.template = ConfirmationView;
    var contactUsState = $state.get('contactUs');
    contactUsState.template = ContactUsView;
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/quoteandbind/common/app.js
// module id = 116
// module chunks = 0